'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { Link } from '@/components/shared/link';
import { Loader } from '@/components/shared/loader';
import { useEnvironment } from '@/contexts/useEnvironment';
export const SsoDropdown = t0 => {
  const $ = _c(35);
  const {
    providers,
    redirecting,
    onRedirect
  } = t0;
  const {
    clientApiBaseUrl
  } = useEnvironment();
  const [anchorEl, setAnchorEl] = useState(null);
  let t1;
  if ($[0] !== clientApiBaseUrl) {
    t1 = provider => `${clientApiBaseUrl}/saml/sso?provider=${encodeURIComponent(provider)}`;
    $[0] = clientApiBaseUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ssoHref = t1;
  const [onlyProvider] = providers;
  if (providers.length === 1 && onlyProvider) {
    const t2 = ssoHref(onlyProvider);
    let t3;
    if ($[2] !== redirecting) {
      t3 = redirecting ? <Loader size="medium" color="inherit" /> : undefined;
      $[2] = redirecting;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        height: "48px"
      };
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== onRedirect || $[6] !== redirecting || $[7] !== t2 || $[8] !== t3) {
      t5 = <Button component={Link} prefetch={false} href={t2} fullWidth={true} variant="contained" disabled={redirecting} onClick={onRedirect} data-testid="login-v2-sso-button" endIcon={t3} sx={t4}>Log In with SSO</Button>;
      $[5] = onRedirect;
      $[6] = redirecting;
      $[7] = t2;
      $[8] = t3;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => setAnchorEl(event.currentTarget);
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== redirecting) {
    t3 = redirecting ? <Loader size="medium" color="inherit" /> : <i className="material-symbols-arrow-drop-down-rounded" />;
    $[11] = redirecting;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: "48px"
    };
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== redirecting || $[15] !== t3) {
    t5 = <Button fullWidth={true} variant="contained" disabled={redirecting} data-testid="login-v2-sso-dropdown" onClick={t2} endIcon={t3} sx={t4}>Log In with SSO</Button>;
    $[14] = redirecting;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = Boolean(anchorEl);
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setAnchorEl(null);
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = `${anchorEl?.offsetWidth ?? 0}px`;
  let t9;
  if ($[18] !== t8) {
    t9 = {
      paper: {
        sx: {
          minWidth: t8
        }
      }
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onRedirect || $[21] !== providers || $[22] !== ssoHref) {
    let t11;
    if ($[24] !== onRedirect || $[25] !== ssoHref) {
      t11 = provider_0 => <MenuItem key={provider_0} component={Link} prefetch={false} href={ssoHref(provider_0)} onClick={() => {
        setAnchorEl(null);
        onRedirect();
      }}>{provider_0}</MenuItem>;
      $[24] = onRedirect;
      $[25] = ssoHref;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    t10 = providers.map(t11);
    $[20] = onRedirect;
    $[21] = providers;
    $[22] = ssoHref;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[27] !== anchorEl || $[28] !== t10 || $[29] !== t6 || $[30] !== t9) {
    t11 = <Menu anchorEl={anchorEl} open={t6} onClose={t7} slotProps={t9}>{t10}</Menu>;
    $[27] = anchorEl;
    $[28] = t10;
    $[29] = t6;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t5) {
    t12 = <>{t5}{t11}</>;
    $[32] = t11;
    $[33] = t5;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};